import { getProjectType } from "/@src/constants/projectTypes";
import {
  GET_PROJECTS,
  SET_PROJECTS_LOADING,
  SET_PROJECTS_FILTERS,
} from "/@src/redux/contants";
import placeholder from "/@src/assets/img/placeholder/placeholder-image.png";

const INIT_STATE = {
  projectsList: [],
  filters: {
    status: ["DRAFT", "PUBLISHED"],
  },
  filteredProjectList: [],
  loading: false,
};

const projectsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      const mappedProjects = action.payload.map((p) => {
        const type = getProjectType(p.type);
        let img = placeholder;
        if (p.thumb) {
          img = p.thumb;
        }
        return {
          ...p,
          img,
          langId: type.langId,
        };
      });
      return {
        ...state,
        projectsList: mappedProjects,
        filteredProjectList: getFilteredProjects(mappedProjects, state.filters),
      };
    case SET_PROJECTS_FILTERS:
      return {
        ...state,
        filters: action.payload,
        filteredProjectList: getFilteredProjects(
          state.projectsList,
          action.payload
        ),
      };
    case SET_PROJECTS_LOADING:
      return { ...state, loading: action.payload };
    default:
      return { ...state };
  }
};

export default projectsReducer;

const getFilteredProjects = (list, filters) => {
  const { status } = filters;
  return status.length
    ? list.filter((project) => status.includes(project.status))
    : list;
};
